import { FormikSelect } from '@elotech/components';

import { useEnumValues } from '../../hooks/useEnumValues';
import { EnumAutocomplete } from '../../type';
import { EnumAutoCompleteProps } from './EnumSearchFactory';

type FactoryProps = {
  enumClassName: string;
  baseUrl?: string;
};

type Props = FactoryProps & EnumAutoCompleteProps;

export const FormikEnumSearchFactory = ({
  enumClassName,
  baseUrl = '/api',
  ...props
}: Props) => {
  const options = useEnumValues(enumClassName, baseUrl);

  return (
    <FormikSelect
      key={`${baseUrl}-${enumClassName}-${options?.length}`}
      loading={!options}
      options={options || []}
      getOptionLabel={(option: EnumAutocomplete) => option.descricao}
      getOptionValue={(option: EnumAutocomplete) => option.codigo}
      {...props}
    />
  );
};
